import React from 'react';
import { Grid } from '@material-ui/core';

import Description from 'components/typography/Description';
import MainTextfield from 'components/textfield/MainTextfield';
import MainAdornment from 'components/textfield/MainAdornment';

const NutricionalDataInput = ({
  nutricionalData = {},
  setNutricionalData,
  errorMessages,
  readOnly = false,
}) => {
  const _extractError = (key) => {
    if (!errorMessages) return null;
    return errorMessages[key];
  };

  const onChange = (key) => (event) => {
    const value = event.target.value;
    const newValue = !value ? '' : parseInt(value);
    setNutricionalData({ ...nutricionalData, [key]: newValue });
  };

  const renderTextfield = ({ key, label, fullWidth, endAdornment }) => {
    return (
      <MainTextfield
        label={label}
        fullWidth={fullWidth}
        value={nutricionalData[key]}
        readOnly={readOnly}
        endAdornment={
          <MainAdornment position="end" isPrimary={false}>
            {endAdornment}
          </MainAdornment>
        }
        onChange={onChange(key)}
        type="number"
        error={!!_extractError(key)}
        helperText={_extractError(key)}
        isPrimary={false}
      ></MainTextfield>
    );
  };

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item style={{ marginBottom: 8 }}>
        <Description>
          <b>Nutricional Data</b>
        </Description>
      </Grid>

      <Grid item style={{ marginBottom: 8 }}>
        {renderTextfield({
          key: 'calories',
          label: 'Calories',
          fullWidth: true,
          endAdornment: 'cal',
        })}
      </Grid>

      <Grid item container spacing={1}>
        <Grid item>
          {renderTextfield({
            key: 'protein',
            label: 'Protein',
            fullWidth: false,
            endAdornment: 'g',
          })}
        </Grid>

        <Grid item>
          {renderTextfield({
            key: 'carbohydrate',
            label: 'Carbohydrate',
            fullWidth: false,
            endAdornment: 'g',
          })}
        </Grid>

        <Grid item>
          {renderTextfield({
            key: 'fat',
            label: 'Fat',
            fullWidth: false,
            endAdornment: 'g',
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default NutricionalDataInput;
